import { useQuery } from 'react-query';
import hash from 'object-hash';
import { UserType } from '../types/types';

const baseRoute = process.env.REACT_APP_BASE_URL;

export interface CuotasType {
  ano: number;
  mes: number;
  monto?: number;
  montoEfectivo?: number;
  montoTransferencia?: number;
  grupo: string;
}

export interface DescuentoType {
  porcentaje: number;
}


async function getCuotasApiCall( user?: UserType | null) {
  if (!user?.token) return null;
  const headers = {
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/cuotas`,
    { headers, method: 'GET' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as CuotasType[];
}

async function setCuotasApiCall(params?:CuotasType[] | null, user?: UserType | null) {
  if (!user?.token) return null;
  if (!params) return null;
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/cuotas`,
    { headers, body: JSON.stringify(params), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as boolean;
}

async function getDescuentoApiCall( user?: UserType | null) {
  if (!user?.token) return null;
  const headers = {
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/descuento`,
    { headers, method: 'GET' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as DescuentoType;
}

async function setDescuentoApiCall(params?:{ value: number } | null, user?: UserType | null) {
  if (!user?.token) return null;
  if (!params) return null;
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${user.token}`,
  };
  const response = await fetch(
    `${baseRoute}/api/descuento`,
    { headers, body: JSON.stringify(params), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as boolean;
}



export function useGetCuotas( user?: UserType | null) {
  return useQuery<CuotasType[] | null, Error>(
    ['getCuotas', hash(user ?? '')],
    () => getCuotasApiCall(user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}

export function useSetCuotas(params?: CuotasType[] | null, user?: UserType | null) {
  return useQuery<boolean | null, Error>(
    ['setCuotas', hash(params ?? ''), hash(user ?? '')],
    () => setCuotasApiCall(params, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}

export function useGetdescuento( user?: UserType | null) {
  return useQuery<DescuentoType | null, Error>(
    ['getDescuento', hash(user ?? '')],
    () => getDescuentoApiCall(user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
    },
  );
}

export function useSetdescuento(params?: { value: number } | null, user?: UserType | null) {
  return useQuery<boolean | null, Error>(
    ['setDescuento', hash(params ?? ''), hash(user ?? '')],
    () => setDescuentoApiCall(params, user), {
      cacheTime: 3600,
      refetchOnWindowFocus: false,
      enabled: false,
    },
  );
}

